import { render, staticRenderFns } from "./ThreadInfo.vue?vue&type=template&id=0c4947af&scoped=true"
import script from "./ThreadInfo.vue?vue&type=script&lang=ts"
export * from "./ThreadInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4947af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4947af')) {
      api.createRecord('0c4947af', component.options)
    } else {
      api.reload('0c4947af', component.options)
    }
    module.hot.accept("./ThreadInfo.vue?vue&type=template&id=0c4947af&scoped=true", function () {
      api.rerender('0c4947af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ThreadInfo.vue"
export default component.exports